import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/Welcome.scss';
import backgroundImage from '../assets/images/back.jpg';

const Welcome = () => {
  const welcomeStyle = {
    background: `linear-gradient(135deg, rgba(26, 54, 93, 0.85) 0%, rgba(229, 62, 62, 0.7) 100%), url(${backgroundImage})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    width: '100%',
    height: '100vh',
    position: 'relative',
    overflow: 'hidden'

  };

  return (
    <section className="welcome" style={welcomeStyle}>
      <div className="welcome-overlay">
        <div className="container">
          <div className="welcome-content">
            <h1>RESEARCH AND CONSULTANCY</h1>
            <p>
              At Dythel Consulting, we redefine the consulting landscape, 
              breaking through traditional systems to bring modern, innovative, 
              and high-quality services to institutions across various sectors. 
              Our approach challenges the status quo by focusing on integrity, 
              expertise, and tailored solutions, allowing our clients to access 
              consultancy that truly meets the demands of today's world.
            </p>
            <div className="welcome-buttons">
              <Link to="/about" className="btn btn-primary">
                <i className="fas fa-book-open"></i>
                Read More
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                <i className="fas fa-paper-plane"></i>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;